var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5226 15.533C10.2282 15.2416 10.2258 14.7667 10.5173 14.4724L14.2022 10.75L4 10.75C3.58578 10.75 3.25 10.4142 3.25 9.99999C3.25 9.58578 3.58579 9.24999 4 9.24999L14.2022 9.25001L10.5172 5.52764C10.2258 5.23328 10.2282 4.75841 10.5226 4.467C10.817 4.17559 11.2918 4.17799 11.5833 4.47236L16.533 9.47237C16.8223 9.76464 16.8223 10.2354 16.533 10.5277L11.5833 15.5276C11.2918 15.822 10.817 15.8244 10.5226 15.533Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "28cb416b1d6699ea7c83b39bd77d033e.svg";
export { ForwardRef as ReactComponent };